<template>
    <div>
        <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
            <chevron-left-icon size="1.5x" class="custom-class" style="vertical-align: top;"></chevron-left-icon>
            <span class="back">Back</span>
        </div>

        <h1 class="mt-2 mb-3 font-regular">
            CBA Reports
        </h1>

        <div class="row">
            <div class="col-12 col-lg-3 col-md-6">
                <div class="form-group">
                    <label for="">What Do You Want Here?</label>
                    <select name="" id="" class=" form-control" v-model="action_type" @change="resetValues">
                        <option value="" disabled>Pick Your Action</option>
                        <option value="non-performing-loans">No Performing Loan 771</option>
                        <option value="loan-breakdown">Loan Breakdown 746</option>
                        <option value="loan-classification">Loan Classification 761</option>
                        <option value="loan-category">Loan Category 762</option>
                        <option value="reward-report">Rewards Report</option>
                        <option value="general-loan-report">General Report</option>
                        <option value="easypay">EasyPay</option>
                        <option value="nano-flow">Nano Flow</option>
                        <option value="bills-payment-report">Bills Payment</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-lg-3 col-md-6">
                <div class="form-group">
                    <label for="">Start Date</label>
                    <input type="date" v-model="start_date" class="form-control" />
                </div>
            </div>
            <div class="col-12 col-lg-3 col-md-6">
                <div class="form-group">
                    <label for="">Stop Date</label>
                    <input type="date" v-model="stop_date" class="form-control" />
                </div>
            </div>
            <div class="col-12 col-lg-3 col-md-6">
                <label for=""></label>
                <button @click="performAction" class="btn btn-primary w-100" :disabled="accountLoading">
                    <span v-if="accountLoading">
                        <loader-icon></loader-icon>
                        <span>Please Wait</span>
                    </span>
                    <span v-else>Perform Action</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BankStatement from "@/components/BankStatement";
import Swal from "sweetalert2";
import ApiService from "@/services/api.service";
import CDataTable from "@/components/CDataTable";
import CPagination from "@/components/CPagination";
import CModal from "@/components/CModal";

import ErrorService from "@/services/error.service";
import KeyValue from "@/components/KeyValue.vue";

export default {
    name: "CbaReports",
    components: {
        BankStatement,
        KeyValue,
        // CCard
    },
    data() {
        return {
            action_type: "bvn",
            start_date: "",
            stop_date: "",
            accountLoading: false,
        };
    },
    computed: {
        permissions() {
            let permissions = this.$store.getters.permissions;
            return permissions;
        },
    },
    methods: {
        resetValues() {
            this.statement = null;
            this.bvnDetails = null;
        },

        async performAction() {
            this.accountLoading = true;
            try {
                let response = await ApiService.post("reports/cba_report", {
                    start_date: this.start_date,
                    end_date: this.stop_date,
                    type: this.action_type
                });
                var url = response.data.data.url
                // open in  new tab
                window.open(url, '_blank');
                this.accountLoading = false;
            } catch (error) {
                console.log(error.response);
                this.accountLoading = false;
                ErrorService.displayErrorAlert(error.response.data);
            }
        },
        async revealBalance() {
            this.accountLoading = true;
            try {
                let response = await ApiService.post(`account/balance`, {
                    account_number: this.account_number
                });
                this.accountLoading = false;
                Swal.fire({
                    title: "Account Balance",
                    text: `₦${response.data.data.available_balance}`,
                    icon: "success",
                    confirmButtonText: "Ok"
                });
            } catch (error) {
                this.accountLoading = false;
                ErrorService.displayErrorAlert(error.response.data);
            }
        }
    }
};
</script>

<style scoped></style>